<template>
  <div v-show="pddTokenPop.isShow" class="pdd-expire-pop" @click.stop>
    <div class="g-close" @click="hideSaasPop">
      <img src="../../assets/icon-close@2x.png" width="12" alt>
    </div>

    <section class="pop-content">
      <div class="g-close" @click="hideSaasPop">
        <img src="../../assets/icon-close@2x.png" width="12" alt>
      </div>
      <header class="header">
        <div>
          <h3 class="title">
            拼多多续期提醒
          </h3>
        </div>
      </header>
      <section class="inner-content">
        <div>
          <p>您好，您的拼多多“多多进宝”账户将于{{ expireDate }}过期（每次绑定有效期6个月），请您重新绑定进行续期。</p>
          <p>过期后，您将无法添加拼多多商品，续期绑定后即可添加拼多多商品</p>
        </div>
      </section>
      <footer class="footer">
        <qc-button @click.stop="showPddBindPop">
          点击续期绑定
        </qc-button>
      </footer>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import commonMixin from '@/mixins/common';

export default {
  name: 'PddTokenExpirePop',
  mixins: [commonMixin],
  data() {
    return {
      step: 1,
    };
  },
  computed: {
    ...mapState({
      profile: state => state.userCenter.profile,
      pddTokenPop: state => state.common.pddTokenPop,
      expireDate: state => state.common.pddTokenExpire,
    }),
    ...mapGetters({
      isBindPdd: 'userCenter/isBindPdd',
      saasInfo: 'userCenter/saasInfo',
    }),
  },
  methods: {
    showPddBindPop() {
      this.$store.commit('common/HIDE_PDD_TOKEN_EXPIRE_POP');
      this.$store.commit('common/SHOW_BIND_SAAS_POP', {
        type: 3,
        isPddRebind: true,
      });
    },
    onClose() {
      this.$store.commit('common/HIDE_PDD_TOKEN_EXPIRE_POP');
    },

    hideSaasPop() {
      this.$store.commit('common/HIDE_PDD_TOKEN_EXPIRE_POP');
    },
  },
};
</script>

<style lang="less" scoped>
@popH: 350px;
@popHeaderH: 100px;
@popFooterH: 80px;

.pdd-expire-pop {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: rgba(33, 33, 33, 0.6);
  .g-close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 20px;
    height: 20px;
    img {
      cursor: pointer;
    }
  }
  .pop-content {
    position: relative;
    width: 600px;
    height: @popH;
    background-color: #fff;
    border-radius: 4px;
    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: @popHeaderH;
      .title {
        margin-bottom: 10px;
        font-size: 22px;
      }
    }
    .inner-content {
      position: relative;
      top: -20px;
      height: calc(@popH - @popHeaderH - @popFooterH);
      width: 80%;
      margin: 0 auto;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        margin-top: 20px;
      }
      .guide-item {
        padding: 20px 10px;
        text-align: center;
        flex: 1;
        .tip {
          margin-bottom: 10px;
        }
        .image {
          height: 240px;
        }
      }
      .guide-item1 {
        display: flex;
        justify-content: center;
        align-items: center;
        .tip {
          margin-top: 20px;
          .em {
            color: var(--ui-main-color);
          }
        }
      }
    }

    .footer {
      display: flex;
      justify-content: center;
      align-items: center;
      height: @popFooterH;
    }
  }
  .pop-content1 {
    position: relative;
    width: 500px;
    height: 500px;
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    .tip {
      margin-top: 20px;
    }
    .panel-wrap {
      position: relative;
      top: 100px;
    }
  }
}
</style>
